/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Icon, Progress, Tooltip } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { useTranslation } from '@scuf/localization';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import FileUploadAction from '../../../context/FileUploadContext/FileUploadActions';
import { useFileUploadContext } from '../../../context/FileUploadContext/FileUploadContext';
import descriptors from '../../../locales/en-US/descriptors';
import FileIcon from '../../../images/FileIcon.svg';

export interface IUploadFile {
  fileId: string;
  displayFileName: string;
  fileName: string;
  fileType: string;
  fileStatus: string;
  createdDate: string;
  fileStatusKey: FileStatusKey;
  message: string;
  progressPercentage: number;
}

export type FileStatusKey =
  | 'Error'
  | 'Uploaded'
  | 'Processed'
  | 'Uploading'
  | 'PartiallyProcessed';

export interface IDataUploadFileTableProps {
  data: Array<IUploadFile>;
}

const DataUploadFileTable = (props: IDataUploadFileTableProps) => {
  const d = descriptors.energyManagement;
  const [t, lng] = useTranslation();
  const { data: apiData } = props;
  const [, dispatch] = useFileUploadContext();
  const showModal = () => dispatch(FileUploadAction.showUploadModal());
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    props.data &&
      props.data.map((item) => {
        setPercent(item.progressPercentage);
      });
  }, [props.data]);

  const statusRender = (celldata: ICellData) => {
    const uploadFileRow: IUploadFile = celldata.rowData;
    return (
      <>
        <span>{uploadFileRow.fileStatus}</span>

        {/* {(uploadFileRow.fileStatusKey === 'Uploading') && (
            <Progress size='xsmall' total={100} percent={uploadFileRow.progressPercentage == 0? undefined : uploadFileRow.progressPercentage}>                  
            </Progress>
        )
        } 
        <span className={uploadFileRow.fileStatus == 'Uploading'? 'fileuploadstatus' : ''}>{uploadFileRow.fileStatusKey === 'Uploading' ? uploadFileRow.progressPercentage : ''}{uploadFileRow.fileStatusKey === 'Uploading' ? '%' : ''} {uploadFileRow.fileStatus}</span> */}

        {(uploadFileRow.fileStatusKey === 'Error' ||
          uploadFileRow.fileStatusKey === 'PartiallyProcessed') && (
          <Tooltip
            element={
              <span className="filelist-status-tootip">
                <Icon name="badge-info" root="common" />
              </span>
            }
            content={uploadFileRow.message}
            position="bottom center"
          />
        )}
      </>
    );
  };
  return (
    <>
      <div
        className={
          apiData && apiData.length > 0
            ? 'fileupload-datatable datatable-fixed-height'
            : 'fileupload-datatable'
        }
      >
        <DataTable
          data={apiData}
          search={true}
          searchPlaceholder={t(d.SEARCHFOR)}
        >
          <DataTable.Column
            field="displayFileName"
            header={t(d.NAME)}
            sortable={true}
            className="fileupload-name"
            renderer={(cellData) => (
              <>
                <img src={FileIcon} /> {cellData.value}{' '}
              </>
            )}
            initialWidth="40%"
          />
          <DataTable.Column
            field="fileType"
            header={t(d.DATATYPE)}
            sortable={true}
          />
          <DataTable.Column
            field="createdDate"
            header={t(d.CREATEDON)}
            initialWidth="18%"
            renderer={(cellData) => (
              <>
                {moment(cellData.value)
                  .locale(lng)
                  .format('MMM DD, YYYY')}
              </>
            )}
          />
          <DataTable.Column
            field="fileStatus"
            header={t(d.STATUS)}
            renderer={statusRender}
            //className="fileStatusforupdateddata"
          />
        </DataTable>
      </div>
      {apiData.length == 0 && (
        <div className="upload-box">
          <div>
            <div className="align-center">{t(d.NOFILESADDEDHEADER)}</div>
            <div className="align-center">{t(d.NOFILESADDEDMESSAGE)}</div>
            <div className="align-center mt-15">
              <Button
                type="primary"
                content={t(d.UPLOADBUTTON)}
                className="upload-button"
                onClick={showModal}
              ></Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default DataUploadFileTable;
